import { render, staticRenderFns } from "./RedirectList.vue?vue&type=template&id=6b821f4a&scoped=true&"
import script from "./RedirectList.vue?vue&type=script&lang=js&"
export * from "./RedirectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b821f4a",
  null
  
)

export default component.exports